<template>
    <main-content>
        <action-bar>
            <router-link to="/money-request-create" class="btn btn-success">{{ $t('money_request.create') }}</router-link>
        </action-bar>
        <money-request-filter :action="filterAction"></money-request-filter>
        <div >
            <div v-if="$can('read', 'payment-link')">
                <kt-datatable ref="datatable" v-bind="datatablePropsWithManage"></kt-datatable>
            </div>
            <div v-else>
                <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
            </div>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import moneyRequestFilter from './components/filter'
import { mapGetters } from "vuex";
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from './datatable/columns';
import manageColumns from './datatable/columnsWithManageAccess';
import actionsColumn from './components/actions-column'
import actionBar from '@/components/custom/action-bar'

export default {
    name: 'money-request',
    components:{
        'main-content': mainContent,
        'money-request-filter': moneyRequestFilter,
        'action-bar': actionBar
    },
    data() {
       return {
           query: {}
       }
    },
    computed: {
        datatablePropsWithManage() {
            return {
                id: 'datatableWithManageAccess',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ApiUrl.path('money-request/fetch'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: manageColumns,
            }
        },
        datatableProps() {
            return {
                id: 'datatable',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ApiUrl.path('money-request/fetch'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
        ...mapGetters('moneyRequest', [
            'status'
        ])
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },
    mounted() {

    }
}
</script>